module.exports = __webpack_public_path__ + "static/img/5523_phase_function_Paper_PointsHejduk_Prediction.dbbb63a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5523_phase_function_Paper_PointsHejduk_Prediction.png
// module id = VGpl
// module chunks = 0